import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialKitService = {
    options: async () => axios.get(`${API_URL}/material-kits/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.description, materials: d.materials}))).catch((err) => { throw err }),
    optionsByStorage: async (storage) => axios.get(`${API_URL}/material-kits/options/all/${storage}`).then(({data}) => data.map(d => ({value: d.id, label: d.description, materials: d.materials}))).catch((err) => { throw err }),
    list: async () => axios.post(`${API_URL}/material-kits/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-kits/${id}`).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/material-kits/${id}`).then(({data}) => data).catch((err) => {throw err}),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-kits/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/material-kits`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialKitService;